import DarkModeOutlined from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlined from '@mui/icons-material/LightModeOutlined';
import { useEffect, useState } from 'react';


const ToogleThemeIcon = () => {
    const [ getThemeMode, setThemeMode ] = useState("light");

    useEffect(() => {
        const savedTheme = window.localStorage.getItem("theme") || "light";
        document.documentElement.setAttribute("data-theme", savedTheme);
        setThemeMode(savedTheme);
    }, []);

    const saveTheme = (themeMode) => {
        if(themeMode === "light"){
            document.documentElement.setAttribute("data-theme", themeMode);
            setThemeMode(themeMode);
        }else{
            document.documentElement.setAttribute("data-theme", themeMode);
            setThemeMode(themeMode);
        }

        localStorage.setItem("theme", themeMode);
    }

    return (
        getThemeMode == "light" ? <DarkModeOutlined className="mr-5 icons-color cursor-pointer" onClick={() => saveTheme("dark")} /> : <LightModeOutlined className="mr-5 icons-color cursor-pointer" onClick={() => saveTheme("light")} />
    )
}

export default ToogleThemeIcon;